import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  SimpleChanges,
  SecurityContext
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { noNoWords } from 'app/constants/no-no-words';
import { TimeAndDateService } from 'app/services/time-and-date-service';

@Component({
  selector: 'app-chat-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss'
})
export class ChatMessageComponent {
  @Input() msg: any;
  @Input() user: any;
  @Input() otherUser: any;
  @Input() enableCensorship: boolean = true;
  @Input() justifyRight: boolean = false;

  formattedMessage: string;

  constructor(private sanitizer: DomSanitizer, private timeAndDate: TimeAndDateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['msg']) {
      this.formattedMessage = this.formatMessage(this.msg.text);
    }
  }

  translateMessageTimestamp(stamp) {
    const jsDate = stamp.toDate();
    const friendly = this.timeAndDate.getFriendlyTimeAgo(jsDate);
    return friendly || 'time error';
  }


  private formatMessage(msg: string): string {
    let cleanMsg = this.enableCensorship ? this.censorBadWords(msg) : msg;

    // Detect phone numbers (basic pattern for North America)
    cleanMsg = cleanMsg.replace(
      /(?:(\+?1[-.\s]*)?\(?\d{3}\)?[-.\s]*\d{3}[-.\s]*\d{4})/g,
      (match) => {
        const digitsOnly = match.replace(/\D/g, '');
        return `<a class="link" href="tel:${digitsOnly}">${match}</a>`;
      }
    );

    // Detect URLs
    cleanMsg = cleanMsg.replace(
      /((https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?)/gi,
      (url) => {
        const href = url.startsWith('http') ? url : `https://${url}`;
        return `<a class="link" href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      }
    );

    return this.sanitizer.sanitize(SecurityContext.HTML, cleanMsg) || '';
  }

  private censorBadWords(text: string): string {
    const pattern = new RegExp(`\\b(${noNoWords.join('|')})\\b`, 'gi');
    return text.replace(pattern, (match) => '*'.repeat(match.length));
  }
}